// This is StockRatioVisualizationContext.js
import { useState } from 'react';

import React, { createContext } from 'react';
import { useLocalStorage } from '../hooks/useLocalStorage';

export const StockRatioVisualizationContext = createContext();

export function StockRatioVisualizationProvider({ children }) {
  const [selectedStock, setSelectedStock] = useLocalStorage('selectedStock', 'AAPL');
  const [selectedPeriod, setSelectedPeriod] = useLocalStorage('ratioVisualizationSelectedPeriod', 'MAX');

  const handleStockChange = (e) => {
    setSelectedStock(e.target.value);
  };

  const handleWatchlistStockChange = (e) => {
    if (e.target.value) {
      setSelectedStock(e.target.value);
    }
  };

  const handlePeriodChange = (period) => {
    const validPeriods = ['1Y', '2Y', '3Y', '4Y', '5Y', 'MAX'];
    if (validPeriods.includes(period)) {
      setSelectedPeriod(period);
    }
  };

  const resetToDefaults = () => {
    setSelectedStock('AAPL');
    setSelectedPeriod('MAX');
  };

const [ratioChartData, setRatioChartData] = useState([]);
const [isRatioChartDataLoaded, setIsRatioChartDataLoaded] = useState(false);

  return (
    <StockRatioVisualizationContext.Provider
      value={{
        selectedStock,
        selectedPeriod,
        setSelectedStock,
        setSelectedPeriod,
        handleStockChange,
        handleWatchlistStockChange,
        handlePeriodChange,
        resetToDefaults,
        ratioChartData,
        setRatioChartData,
       isRatioChartDataLoaded,
       setIsRatioChartDataLoaded
      }}
    >
      {children}
    </StockRatioVisualizationContext.Provider>
  );
}
